const categories = [
  { label: '音乐综艺', icon: 'ri-music-2-line', color: 'bg-accent-100 text-accent-700' },
  { label: '户外真人秀', icon: 'ri-compass-3-line', color: 'bg-primary-100 text-primary-700' },
  { label: '脱口秀', icon: 'ri-emotion-laugh-line', color: 'bg-accent-100 text-accent-700' },
  { label: '选秀节目', icon: 'ri-star-line', color: 'bg-primary-100 text-primary-700' },
  { label: '美食综艺', icon: 'ri-restaurant-line', color: 'bg-accent-100 text-accent-700' },
  { label: '旅行综艺', icon: 'ri-flight-takeoff-line', color: 'bg-primary-100 text-primary-700' },
  { label: '情感观察', icon: 'ri-heart-line', color: 'bg-accent-100 text-accent-700' },
  { label: '竞技挑战', icon: 'ri-sword-line', color: 'bg-primary-100 text-primary-700' },
];

export default function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            综艺分类
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            按类型快速筛选，找到你最想看的综艺节目
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat, index) => (
            <a
              key={index}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`flex items-center gap-3 px-5 py-4 rounded-xl ${cat.color} transition-all hover:-translate-y-1 cursor-pointer`}
            >
              <i className={`${cat.icon} text-lg`}></i>
              <span className="text-sm font-bold whitespace-nowrap">{cat.label}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}